<div class="position-relative">
    <div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom px-4 py-3 secondary-nav" style="position: fixed; top:65px; z-index:5;">
        <div class="d-flex flex-column col">
            <h3 class="mt-0 mb-1">Add Vehicle</h3>
            <p-breadcrumb [model]="items"></p-breadcrumb>
        </div>
        <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
            <button pButton pRipple type="button" label="Clear All" class="p-button-outlined p-button-secondary me-3"></button>
            <button pButton pRipple type="button" label="Save Vehicle"></button>
        </div>
    </div>
</div>

<div style="padding-top:72px;">
    <div class="p-white shadow m-3 p-4">
        <div class="col-12 col-sm-12">
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Vehicle numberplate ID *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Vehicle model *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Driver Name *</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Driver mobile number</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-4 mb-lg-0 mb-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Fule Type *</label>
                                <p-dropdown placeholder="Select Fule Type" optionLabel="name"></p-dropdown>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Manufactured year</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-4">
                            <div class="d-flex flex-column">
                                <label class="mb-2">Registered Year</label>
                                <input type="text" pInputText> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


